package com.example.mystybag.login.model

data class EnterEmailUIState(
    val email               : String                = "",
    val emailErrorMsg       : String                = "",
    val emailIsError        : Boolean               = false,
    var description         : String                = "",
    val isLoading           : Boolean               = false
)
